import React from 'react';
import { Box, MenuItem, Select } from '@mui/material';

interface SteielSelectProps {
  allowedValues: string[];
  onChange: (value: string) => void;
  initialVal?: string;
}

const SteielSelect: React.FC<SteielSelectProps> = ({ initialVal, onChange, allowedValues }) => {
  const compIdRef = React.useRef(`${Date.now()}_${Math.random()}`);
  if (allowedValues.length === 0) {
    return null;
  }

  // Controlled from parent so values stay in sync (e.g. Formik reinitialize, Apollo cache updates).
  const displayValue = allowedValues.includes(initialVal ?? '')
    ? (initialVal as string)
    : (allowedValues[0] ?? '');

  const menuItems: React.ReactNode[] = [];
  for (let i = 0; i < allowedValues.length; i++) {
    const allowedValue = allowedValues[i];
    menuItems.push(
      <MenuItem key={allowedValue} value={allowedValue}>
        {`${allowedValue}`}
      </MenuItem>,
    );
  }
  return (
    <Box>
      <Select
        labelId={`label id select_${compIdRef.current}`}
        id={`id-select-${compIdRef.current}`}
        value={displayValue}
        size='small'
        fullWidth
        style={{ fontSize: '1.1rem', height: 40 }}
        onChange={(e) => {
          onChange(e.target.value as string);
        }}
      >
        {menuItems}
      </Select>
    </Box>
  );
};

export default SteielSelect;
